import { Button, Col, Input, message, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./TesBreakdownForm.css";
import axios from "axios";
import { url } from "../../constant/url";
import { LeftOutlined } from "@ant-design/icons";
import _ from "underscore";

const { Option } = Select;

function TesBreakdownForm({ history, match }) {
  const [data, setData] = useState({
    name: "",
    parent_id: "",
    parent_name: "",
    plan_id: "",
    plan_name: "",
    main_process_name: "",
    line_process_name: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [parents, setParents] = useState([]);
  const [lines, setLines] = useState([]);
  const [mains, setMains] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [page] = useState(1);
  const [perpage] = useState(10);
  const [sort] = useState({
    sort: "created_at",
    order: "ascend",
  });

  useEffect(() => {
    if (match.params.id) {
      getData();
    }
  }, []);

  const handleChange = (name, value) => {
    setErrors({
      ...errors,
      [name]: "",
    });

    setData({
      ...data,
      [name]: value,
    });
  };

  const getData = () => {
    setLoading(true);
    axios
      .get(`${url}/breakdown/${match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setData({
          ...data,
          name: res.data.data.name,
          parent_id: res.data.data.parent_id,
          parent_name: res.data.data.parent_name,
          plan_id: res.data.data.plan_id,
          plan_name: res.data.data.plan_name,
          main_processes: res.data.data.breakdown_main.map((x) => {
            return {
              key: x.main_process_id,
              value: x.main_process_id,
              label: x.main_process_name,
            };
          }),
          line_processes: res.data.data.breakdown_line.map((x) => {
            return {
              key: x.line_process_id,
              value: x.line_process_id,
              label: x.line_process_name,
            };
          }),
        });
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleReset = () => {
    setData({
      name: "",
      parent_id: "",
      parent_name: "",
      plan_id: "",
      plan_name: "",
      main_processes: [],
      line_processes: [],
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        match.params.id
          ? `${url}/breakdown/${match.params.id}`
          : `${url}/breakdown`,
        {
          name: data.name,
          parent_id: data.parent_id,
          parent_name: data.parent_name,
          plan_id: data.plan_id,
          plan_name: data.plan_name,
          main_processes: data.main_processes,
          line_processes: data.line_processes,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        message.success(res.data.message);
        history.push("/tes-breakdown");
      })
      .catch((err) => {
        if (err.response) {
          setErrors(err.response.data.errors);
          message.error(err.response.data.message);
        }
        setLoading(false);
      });
  };

  const getParent = async (keyword) => {
    await axios
      .get(`${url}/breakdown/list`, {
        params: {
          keyword,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setParents(res.data.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            localStorage.removeItem("token");
          }
        }
      });
  };

  const getLine = async (keyword) => {
    await axios
      .get(`${url}/mapping-process/list-line`, {
        params: {
          keyword,
          limit: perpage,
          page,
          sortBy: `${sort.sort}:${sort.order}`,
          plan_id: data.plan_id,
          main_process_id: JSON.stringify(
            _.pluck(data.main_processes, "value")
          ),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setLines(res.data.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            localStorage.removeItem("token");
          }
        }
      });
  };

  const getMain = async (keyword) => {
    await axios
      .get(`${url}/mapping-process/list-main`, {
        params: {
          keyword,
          limit: perpage,
          page,
          sortBy: `${sort.sort}:${sort.order}`,
          plan_id: data.plan_id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setMains(res.data.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            localStorage.removeItem("token");
          }
        }
      });
  };

  const getDepartment = async (keyword) => {
    await axios
      .get(`${url}/mapping-process/list-plan`, {
        params: {
          keyword,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setDepartments(res.data.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            localStorage.removeItem("token");
          }
        }
      });
  };

  const handleChangeSelect = (name, value) => {
    setErrors(null);
    if (value) {
      setData({
        ...data,
        main_processes: [],
        line_processes: [],
        [`${name}_id`]: value.value,
        [`${name}_name`]: value.label,
      });
    } else {
      setData({
        ...data,
        [`${name}_id`]: null,
        [`${name}_name`]: null,
      });
    }
  };

  const handleChangeSelectMultiple = (name, value) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  // const handleChangeSelectDept = (name, value) => {
  //   setErrors(null);

  //   if (value) {
  //     const findBreakdown = departments.find((x) => x._id === value.value);
  //     if (findBreakdown) {
  //       setData({
  //         ...data,
  //         main_processes: false,
  //         line_processes: ,
  //         [`${name}_id`]: value.value,
  //         [`${name}_name`]: value.label,
  //       });
  //     }
  //   } else {
  //     setData({
  //       ...data,
  //       [`${name}_id`]: value.value,
  //       [`${name}_name`]: value.label,
  //     });
  //   }
  // };

  const handleChangeSelectParent = (name, value) => {
    setErrors(null);

    if (value) {
      const findParent = parents.find((x) => x._id === value.value);
      if (findParent) {
        setData({
          ...data,
          plan_id: findParent.plan_id,
          plan_name: findParent.plan_name,
          main_processes: findParent.breakdown_main.map((x) => {
            return {
              key: x.main_process_id,
              value: x.main_process_id,
              label: x.main_process_name,
            };
          }),
          line_processes: findParent.breakdown_line.map((x) => {
            return {
              key: x.line_process_id,
              value: x.line_process_id,
              label: x.line_process_name,
            };
          }),
          [`${name}_id`]: value.value,
          [`${name}_name`]: value.label,
        });
      }
    } else {
      setData({
        ...data,
        plan_id: "",
        plan_name: "",
        main_processes: [],
        line_processes: [],
        parent_id: "",
        parent_name: "",
      });
    }
  };

  console.log(errors);

  return (
    <div>
      <ul className="breadcumb">
        <li>
          <Link to="/tes-breakdown">
            <LeftOutlined />
            Breakdown
          </Link>
        </li>
        <li className="active">
          {match.params.id ? "Edit Breakdown" : "Add Breakdown"}
        </li>
      </ul>
      <div className="content">
        <form onSubmit={handleSave}>
          <Row gutter={20}>
            <Col md={18} xs={24}>
              <div className="form-group">
                <label className="form-label">
                  Name <span className="error-text">*</span>
                </label>
                <Input
                  value={data.name}
                  className={errors && errors.name ? "is-error" : ""}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
                {errors && errors.name && (
                  <span className="error-text">{errors.name[0]}</span>
                )}
              </div>
              <div className="form-group">
                Parent
                {/* <span className="error-text">*</span> */}
                <Select
                  allowClear
                  style={{ width: 693 }}
                  labelInValue
                  onChange={(value) =>
                    handleChangeSelectParent("parent", value)
                  }
                  onFocus={() => getParent("")}
                  showSearch
                  onSearch={(value) => getParent(value)}
                  filterOption={false}
                  value={{
                    key: data._id,
                    label: data.parent_name,
                  }}
                >
                  {parents &&
                    parents.map((parent) => {
                      return (
                        <Option value={parent._id} key={parent._id}>
                          {parent.name}
                        </Option>
                      );
                    })}
                </Select>
                {errors && errors.parent_name && (
                  <span className="error-text">{errors.parent_name[0]}</span>
                )}
              </div>

              <div className="form-group">
                Department <span className="error-text">*</span>
                <Select
                  allowClear
                  disabled={
                    data.parent_id == "" || data.parent_id == null
                      ? false
                      : true
                  }
                  style={{ width: 693 }}
                  labelInValue
                  onChange={(value) => handleChangeSelect("plan", value)}
                  onFocus={() => getDepartment("")}
                  showSearch
                  onSearch={(value) => getDepartment(value)}
                  filterOption={false}
                  value={{
                    key: data.plan_id,
                    label: data.plan_name,
                  }}
                >
                  {departments &&
                    departments.map((dept) => {
                      return (
                        <Option value={dept._id} key={dept._id}>
                          {dept.name}
                        </Option>
                      );
                    })}
                </Select>
                {errors && errors.plan_name && (
                  <span className="error-text">{errors.plan_name[0]}</span>
                )}
              </div>

              <div className="form-group">
                Main Process Name<span className="error-text">*</span>
                <Select
                  disabled={
                    data.parent_id == "" || data.parent_id == null
                      ? false
                      : true
                  }
                  style={{ width: 693 }}
                  labelInValue
                  onChange={(value) =>
                    handleChangeSelectMultiple("main_processes", value)
                  }
                  onFocus={() => getMain("")}
                  showSearch
                  onSearch={(value) => getMain(value)}
                  filterOption={false}
                  mode="multiple"
                  value={data.main_processes}
                >
                  {mains &&
                    mains.map((main) => {
                      return (
                        <Option
                          value={main.main_process_id}
                          key={main.main_process_id}
                        >
                          {main.main_process_name}
                        </Option>
                      );
                    })}
                </Select>
                {errors && errors.main_processes && (
                  <span className="error-text">{errors.main_processes[0]}</span>
                )}
              </div>
              <div className="form-group">
                Line Process Name
                <Select
                  disabled={
                    data.parent_id == "" || data.parent_id == null
                      ? false
                      : true
                  }
                  style={{ width: 693 }}
                  labelInValue
                  onChange={(value) =>
                    handleChangeSelectMultiple("line_processes", value)
                  }
                  onFocus={() => getLine("")}
                  showSearch
                  onSearch={(value) => getLine(value)}
                  filterOption={false}
                  mode={"multiple"}
                  value={data.line_processes}
                >
                  {lines &&
                    lines.map((line) => {
                      return (
                        <Option
                          value={line.line_process_id}
                          key={line.line_process_id}
                        >
                          {line.line_process_name}
                        </Option>
                      );
                    })}
                </Select>
                {errors && errors.line_processes && (
                  <span className="error-text">{errors.line_processes[0]}</span>
                )}
              </div>

              <div className="form-group">
                <Button
                  type="primary"
                  onClick={handleSave}
                  loading={loading}
                  style={{ backgroundColor: "#1b2086", borderColor: "#1b2086" }}
                >
                  {/* <i className="mdi mdi-content-save mr-5" />  */}
                  Submit
                </Button>

                <Button
                  htmlType="reset"
                  type="primary"
                  onClick={handleReset}
                  // loading={loading}
                  style={{
                    backgroundColor: "#1b2086",
                    marginLeft: 10,
                    borderColor: "#1b2086",
                  }}
                >
                  {/* <i className="mdi mdi-content-save mr-5" /> */}
                  Reset
                </Button>
              </div>
            </Col>
          </Row>
        </form>
      </div>
    </div>
  );
}

export default TesBreakdownForm;
